ApplicationAdapter = require './application'
NestedResource      = require 'mixins/nested-resource'

module.exports = App.OrderBuddyAdapter = ApplicationAdapter.extend NestedResource,
  parentType:         'order'
  parentRelationship: 'buddies'
